module.exports = __webpack_public_path__ + "img/singleLineTextEle.d244d83f.svg";